// ** MUI Imports
import Box from "@mui/material/Box";

// ** Footer Content Component
import FooterContent from "./FooterContent";
import { useRouter } from "next/router";
const DISABLE_FOOTER_URL_PATH = ["/orders", "/profile", "/tickets"];

const Footer = (props) => {
  const router = useRouter();

  const isFooterNotShow = DISABLE_FOOTER_URL_PATH.some(
    (path) => router.pathname === path
  );

  const isNavLinkActive = () => {
    if (router.pathname === item.path || handleURLQueries(router, item.path)) {
      return true;
    } else {
      return false;
    }
  };

  if (isFooterNotShow) {
    return null;
  }
  return (
    <Box
      component="footer"
      className="layout-footer"
      mt={20}
      p={10}
      sx={{
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000",

        // ...(footer === 'fixed' && {
        //   bottom: 0,
        //   position: 'sticky',
        //   ...(layout === 'vertical'
        //     ? { px: [4, 6] }
        //     : {
        //         backgroundColor: theme => theme.palette.background.paper,
        //         ...(skin === 'bordered'
        //           ? { borderTop: theme => `1px solid ${theme.palette.divider}` }
        //           : { boxShadow: 16 })
        //       })
        // }),
        // ...footerStyles
      }}
    >
      <Box
        className="footer-content-container"
        sx={{
          px: { xs: 2, lg: 7 },
          width: "100%",
          pt: (theme) => theme.spacing(3),

          // ...(contentWidth === 'boxed' && { '@media (min-width:1440px)': { maxWidth: 1440 } }),
          borderTopLeftRadius: (theme) => theme.shape.borderRadius,
          borderTopRightRadius: (theme) => theme.shape.borderRadius,

          // ...(footer === 'fixed' && {
          //   ...(contentWidth === 'boxed' &&
          //     layout === 'vertical' && {
          //       '@media (min-width:1440px)': { maxWidth: theme => `calc(1440px - ${theme.spacing(6)} * 2)` }
          //     }),
          //   ...(layout === 'vertical' && {
          //     ...(skin === 'bordered'
          //       ? { border: theme => `1px solid ${theme.palette.divider}`, borderBottomWidth: 0 }
          //       : { boxShadow: 16 })
          //   })
          // })
        }}
      >
        <FooterContent />
      </Box>
    </Box>
  );
};

export default Footer;
